module.exports = __webpack_public_path__ + "img/loan-rating.245dd559.svg";